import React, { useContext } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./header-active-panel.scss";

import { Avatar, Badge, DropdownMenu, Text, Button } from "@ui-kit";
import { UserContext, useDropdownMenu } from "@shared/hooks";
import { geShortCut } from "@shared";
import {
  //CART_URL,
  CAREER_URL,
} from "@app/routes";
import { AvatarLabel, HeaderActiveLang, Notifications } from "@features";
import { userGetLocaleSC } from "@entities/user/model/user.selectors";
import { ROLES } from "@entities/user/model/user.constants";
import {
  userSetLocaleAC,
  userSetModalLoginShowAC,
  userSetModalSignupShowAC,
} from "@entities/user/model/user.actions";
//const CartGray = '/images/icons/cart-gray500.svg';
const LogoutSmal = "/images/icons/logout-gray700.svg";

import { MENU_LIST, MENU_LIST_ADMIN } from "./header-active.consts";

const HeaderPanel = ({ logout = () => {} }) => {
  const dispatch = useDispatch();
  const user = useContext(UserContext);
  const locale = useSelector(userGetLocaleSC);
  const { pathname } = useLocation();
  const { visible, togglePopover, hidePopover, showPopover } =
    useDropdownMenu();
  //const [showMenu, setShowMenu] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const { isUserAuth = null, isUserOnline = false, ava = null } = user;

  const IS_CAREER_PAGE = pathname === CAREER_URL.pathname;
  const langTitle = locale === "ru" ? "Ru" : "En";
  const isUser = user.role === ROLES.USER;
  const userMenu = isUser ? MENU_LIST : MENU_LIST_ADMIN;
  //const cartCount = user.cart.length || 0;
  //const bellURL = isUser ? ADMIN_USER_PROJECTS_URL.pathname : ADMIN_PROJECTS_URL.pathname;

  const selectLanguage = (value) => {
    dispatch(userSetLocaleAC(value));
    searchParams.set("lang", value);
    setSearchParams(searchParams, { replace: true });
  };

  const LOGOUT_COMPONENT = {
    component: (
      <Text as="span" onClick={logout} className="menu_logout">
        Log out
      </Text>
    ),
    icon: LogoutSmal,
  };

  let menuListWithAvatarLabel = [
    {
      component: (
        <AvatarLabel
          author={user}
          showEmail={true}
          className="menu-hover__disabled"
        />
      ),
      isDivider: true,
    },
    ...userMenu,
    LOGOUT_COMPONENT,
  ];

  const renderBadge = (counter) => {
    if (!counter) {
      return;
    }

    return (
      <Badge
        text={counter}
        size="md"
        theme="success"
        className="header__wrapper-badge"
      />
    );
  };

  const onClickInternal = (value) => {
    togglePopover();
    //setShowMenu(value);
  };

  const onVisibleChange = (event) => {
    const value = event?.value;
    if (value) {
      showPopover();
    } else {
      hidePopover();
    }
    //setShowMenu(false);
  };

  const viewModalLogin = () => {
    dispatch(userSetModalSignupShowAC(false));
    dispatch(userSetModalLoginShowAC(true));
  };

  const viewModalSignup = () => {
    dispatch(userSetModalLoginShowAC(false));
    dispatch(userSetModalSignupShowAC(true));
  };

  const getActions = () => {
    if (isUserAuth) {
      return (
        <div className="d-flex ai-center">
          {IS_CAREER_PAGE && (
            <HeaderActiveLang
              title={langTitle}
              selectLanguage={selectLanguage}
              className="mr-30"
            />
          )}

          <Notifications user={user} isUser={isUser}>
            {renderBadge(user?.notifications?.length)}
          </Notifications>

          {/*<div className="d-flex header__link-cart">
            <Link
              to={CART_URL}
              iconLeft={CartGray}
              alt="cart icon"
              size="sm"
              theme="text"
              className={` d-flex ai-center}`}
            />
            {renderBadge(cartCount)}
          </div>*/}

          <DropdownMenu
            menu_list={menuListWithAvatarLabel}
            onVisibleChange={onVisibleChange}
            isVisible={visible}
            classes="menu-default"
            placement="bottomLeft"
          >
            <Avatar
              isUserOnline={isUserOnline}
              src={ava}
              status={true}
              className="drop-down__ava"
              text={geShortCut(user.firstName, user.lastName)}
              onClick={onClickInternal}
            />
          </DropdownMenu>
        </div>
      );
    }

    return (
      <div className="d-flex ai-center ml-18 notauth">
        {IS_CAREER_PAGE && (
          <HeaderActiveLang title={langTitle} selectLanguage={selectLanguage} />
        )}
        <Button onClick={viewModalLogin} theme="tertiary-gray">
          Log in
        </Button>
        <Button onClick={viewModalSignup} className="ml-12" size="lg">
          Sign up
        </Button>
      </div>
    );
  };

  return <div className="header__panel d-flex ai-center">{getActions()}</div>;
};

export default HeaderPanel;
